import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AdddoctypepopupComponent } from '../../generalpopup/adddoctypepopup/adddoctypepopup.component';

@Component({
  selector: 'app-adddocument',
  templateUrl: './adddocument.component.html',
  styleUrls: ['./adddocument.component.css']
})
export class AdddocumentComponent implements OnInit {

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private toastr: ToastrService,private appService: AppdataService,
    private loginService:LoginserviceService,private activeModal: NgbActiveModal,private confirmationDialogService: ConfirmationDialogService,
    private productFindService: NgbModal,) {
      
      this.dateCustomClasses = [
        { date: new Date(), classes: ['bg-warning'] },
      ];

     }

//Save Validation
submitted:boolean;
successfully:boolean;

documentform=new FormGroup({
  doctypeid:new FormControl(0,Validators.required),          
  docnum:new FormControl(null,Validators.required),   
  issuedt:new FormControl(null,Validators.required),   
  expirydt:new FormControl(null,Validators.required),   
  descr: new FormControl(''),  
  inactive:new FormControl(false),  
});

//Edit Get Values
doctypeColl:any=[];

@Input() documentid:any=0;
@Input() doctypeid:any=null
@Input() docnum:any=null;
@Input() issuedt:any=null;
@Input() expirydt:any=null;
@Input() descr:any=null;
@Input() inactive:any=false;
@Input() trxtype: string = "";
  
@Output() emitData = new EventEmitter();


isdocnumber: boolean=false;
isissuedt: boolean=false;
isexpirydt: boolean=false;
  
ngOnInit() {

this.documentform.reset();
this.fnInitializeFormGroup(); 
this.fngetDocType();
}

fnInitializeFormGroup(){
this.documentform.setValue({
  doctypeid:this.doctypeid,    
  docnum:this.docnum,   
  issuedt:this.issuedt,   
  expirydt:this.expirydt,   
  descr: this.descr,    
  inactive:this.inactive
})
  
  
this.fnChangeDocType();
}

//Get 
fngetDocType() {
  var data = {
  'doctypeid':0,
  'companyid': this.loginService.fnGetCompanyId(),
  'doctype':this.fnGetDocTypeSection(),
  
  }
  this.appService.getDocType(data)
  .subscribe(
  (res)=>{                
    if(res.json().status===200){  
      this.doctypeColl = res.json().result;
    
      this.fnChangeDocType();
  }
  else {
  this.loginService.fnAPIError(res.json())
  }

  },
  (err)=>{          
  this.toastr.error('Error', err);
  })
}

fnChangeDocType() {
  
    this.isdocnumber = false;
    this.isexpirydt = false;
    this.isissuedt = false;

    
    var doctypeid = this.documentform.get('doctypeid').value;
   

    for (let abo of this.doctypeColl) {
      if (doctypeid === abo.doctypeid) {
        this.isdocnumber = abo.isdocnum;
        this.isexpirydt = abo.isexpirydt;
        this.isissuedt = abo.isissuedt;
      }
    }


    this.fnUpdatePayType();
  
}  

fnUpdatePayType() {

    if (this.isdocnumber) {
      this.documentform.controls['docnum'].setValidators(Validators.required);   
    }
    else {
      this.documentform.controls['docnum'].clearValidators();
      this.documentform.controls['docnum'].setErrors(null);
      this.documentform.controls['docnum'].setValidators(null);
    }
    
    
    if (this.isissuedt) {
      this.documentform.controls['issuedt'].setValidators(Validators.required);   
    }
    else {
      this.documentform.controls['issuedt'].clearValidators();
      this.documentform.controls['issuedt'].setErrors(null);
      this.documentform.controls['issuedt'].setValidators(null);
    }

    
    if (this.isexpirydt) {
      this.documentform.controls['expirydt'].setValidators(Validators.required);   
    }
    else {
      this.documentform.controls['expirydt'].clearValidators();
      this.documentform.controls['expirydt'].setErrors(null);
      this.documentform.controls['expirydt'].setValidators(null);
    }
}
  
  
fnSaveBtnClick(){
try{
  this.submitted=true;
  this.successfully=false;
  //Validate
  if(this.documentform.valid){

    if (this.isissuedt && this.isexpirydt) {
      var _issuedt = this.documentform.get('issuedt').value;
      var _expirydt = this.documentform.get('expirydt').value;

      if(Date.parse(_expirydt)<Date.parse(_issuedt)){
        this.documentform.controls['expirydt'].setErrors({'notfound': true});
        return
      }
    }


  const index = this.doctypeColl.findIndex(sku => sku.doctypeid === this.documentform.get('doctypeid').value); 

  //Check
  var data = {
    documentid: this.documentid,                      
    doctypeid:this.documentform.get('doctypeid').value,     
    docnum:this.documentform.get('docnum').value,     
    issuedt:this.documentform.get('issuedt').value,   
    expirydt:this.documentform.get('expirydt').value,   
    descr: this.documentform.get('descr').value,     
    inactive: this.documentform.get('inactive').value,     
  }
  this.emitData.emit(data);  
  this.activeModal.close(true);  

}

}catch(ex){
this.fnShowErrorMsg(ex);
}
}

fnGetDocTypeSection() {

  if (this.trxtype === 'COMPANY') {
    return 'COMPANY'
  }
  else  if (this.trxtype === 'BRANCH') {
    return 'BRANCH'
  }
  else {
    return 'EMPLOYEE'
  }

}

//AddDeduction
private fnAddDoctype() {

  const modalRef = this.productFindService.open(AdddoctypepopupComponent, { size: <any>'xl' });

  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

    this.fngetDocType();

    if (receivedEntry > 0) {
      this.documentform.patchValue({ doctypeid: receivedEntry })
    }
  });

}

public decline() {
this.activeModal.close(false);
}


private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}



}
